import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { fontSize } from '@css/styles';
import { FontNormal } from '@css/fonts';
import {black, gray, lightGray, marketingMobileCuttoff} from '@css/constants';
import { Icon } from '@components/Icons/ChevronRight.elements';
import { Card } from '@css/common.elements';

export const ContentCardWrapper = styled(Card)(css`
  height: 176px;
  width: 327px;
  margin: 10px;
  align-self: center;
  border: 1px solid ${lightGray};
  
  @media(max-width: ${marketingMobileCuttoff}) {
    margin: 20px auto;
  }
`);

export const ContentCardLink = styled('a')(css`
  text-decoration: none;
  outline: 0;
  display: flex;
  flex-direction: column;
  height: 176px;
  width: 327px;
`);

export const ContentCardBadgeText = styled('p')(css`
  ${FontNormal(600)};
  font-size: 20px;
  width: 50%;
  text-align: center;
  color: ${black};
  margin: 4px 0 0 0;
`);

type ContentCardImageProps = {
  imageUrl: string;
}


export const ContentCardImage = styled.div<ContentCardImageProps>`
  border-radius: 0;
  flex: 1;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  background-image: url(${props => props.imageUrl});
  position: relative;
  max-height: 88px;
`;

export const ContentCardContent = styled('div')(css`
  border-radius: 0;
  height: 87px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  position: relative;

  ${Icon} {
    position: absolute;
    color: ${gray};
    right: 16px;
    top: 34.5px;
  }
`);

export const ContentCardTitle = styled('span')(css`
  ${FontNormal(600)};
  font-size: 20px;
  color: ${black};
  width: 80%;
  margin-left: 24px;
`);
